import { render, staticRenderFns } from "./dormSub.vue?vue&type=template&id=407c0136&scoped=true"
import script from "./dormSub.vue?vue&type=script&lang=js"
export * from "./dormSub.vue?vue&type=script&lang=js"
import style0 from "./dormSub.vue?vue&type=style&index=0&id=407c0136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c0136",
  null
  
)

export default component.exports